export default __webpack_public_path__ + "static/media/c1.efe75a23.png";